
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/donate-skill",
      function () {
        return require("private-next-pages/donate-skill/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/donate-skill"])
      });
    }
  